// src/js/reducers/index.js
import { START_CLICK, MODULE_CLICK, SUBMODULE_CLICK, ANSWER_CLICK, UPDATE_FORM_FIELD, SUBMIT_FORM } from "../constants/action-types";
import data from '../../data/data.json';
import axios from 'axios-jsonp-pro';

const BitlyClient = require('bitly').BitlyClient;
const bitly = new BitlyClient('1a08e7007495876befd3c626207237cf5d9b070d');

// state - initial starting point
const initialState = {
    data : data,
    actionclasses : {
        intro: "",
        modulecomplete: [
            "",
            ""
        ]
    },
    steps : [
        { step : 0 },
        { step : 0 }
    ],
    results : [],
    outputresults : [],
    displayresults : false,
    questionsubmitactive: false,
    form : {
        firstname : "",
        lastname : "",
        email : "",
        phone : "",
        organisation : "",
        jobtitle : ""
    },
    formtypes : {
        firstname : "text",
        lastname : "text",
        email : "email",
        phone : "phone",
        organisation : "text",
        jobtitle : "text"
    },
    formerrors : {
        firstname : false,
        lastname : false,
        email : false,
        phone : false,
        organisation : false,
        jobtitle : false,
    },
    formvalid : true,
    formsent : false,
    resultsurl : ""
};

// state - directly to answers
// const initialState = {
//     data : data,
//     actionclasses : {
//         intro: "hide remove",
//         modulecomplete: [
//             "hide remove",
//             "hide remove"
//         ]
//     },
//     steps : [
//         { step : 7 },
//         { step : 4 }
//     ],
//     results : [
//         [
//             {answer:3, weight: 100},
//             {answer:2, weight: 50},
//             {answer:3, weight: 75},
//             {answer:2, weight: 50},
//             {answer:3, weight: 75}
//         ],
//         [
//             {answer:2, weight: 50},
//             {answer:2, weight: 50}
//         ],
//     ],
//     outputresults : [],
//     displayresults : true,
//     questionsubmitactive: false,
//     form : {
//         firstname : "Adrian",
//         lastname : "Wagner",
//         email : "adrian.wagner@governanceevaluator.com",
//         phone : "0433376467",
//         organisation : "Governance Evaluator",
//         jobtitle : "IT Operations Manager"
//     },
//     formtypes : {
//         firstname : "text",
//         lastname : "text",
//         email : "email",
//         phone : "phone",
//         organisation : "text",
//         jobtitle : "text"
//     },
//     formerrors : {
//         firstname : false,
//         lastname : false,
//         email : false,
//         phone : false,
//         organisation : false,
//         jobtitle : false,
//     },
//     formvalid : true,
//     formsent : false,
//     resultsurl : ""
// };

function rootReducer(state = initialState, action) {

    // todo this is here for function testing purposes - needs to be removed/commented out for final build and original results set or it won't work properly.
    // if (state.outputresults.length === 0) {
    //     return Object.assign({}, state, { outputresults: calculateFinalResults(state.data.questionnaire.modules, state.results) });
    // }

    if (action.type === START_CLICK) {
        return Object.assign({}, state, { actionclasses: { ...state.actionclasses, intro : "hide remove" } }, {steps: [ {step : 1} , {step :0} ]} );
    }

    if (action.type === MODULE_CLICK) {
        return Object.assign({}, state, {steps: IncrementStep( state.steps, action.payload )} );
    }

    if(action.type === SUBMODULE_CLICK) {
        let displayResults = false;
        let newStep = IncrementStep( state.steps, action.payload );
        let nextModule = parseInt(action.payload,10) + 1;
        let totalModules = state.data.questionnaire.modules.length;
        let totalSubmodules = state.data.questionnaire.modules[action.payload].submodules.length + 2; // we add 2 to account for the two additional initial steps
        let outputresults = state.outputresults;

        // check if we've passed the last question module and need to activate the next one.
        if ( newStep[action.payload].step >= totalSubmodules ) {
            if( nextModule >= totalModules ) {
                outputresults = calculateFinalResults(state.data.questionnaire.modules, state.results);
                displayResults = true;
            } else {
                // we need to either move to the next step
                newStep = IncrementStep( newStep, nextModule );
            }
        }
        return Object.assign({}, state, { displayresults : displayResults, steps: newStep, questionsubmitactive: false, outputresults: outputresults } );
    }

    if(action.type === ANSWER_CLICK) {
        return Object.assign({}, state, { results: UpdateResult( state.results, action.payload.module, action.payload.submodule, action.payload.answer, action.payload.weight, state.data.questionnaire.modules[action.payload.module].totalquestions ), questionsubmitactive: true } );
    }

    if (action.type === UPDATE_FORM_FIELD) {
        return Object.assign({}, state, {form: UpdateFormData(state.form , action.payload.name, action.payload.value)});
    }

    if (action.type === SUBMIT_FORM) {
        let formsent = false;
        let resultsurl = null;
        let formvalidation = ValidateForm(state.form, state.formtypes, state.formerrors);

        if(formvalidation.formvalid) {
            resultsurl = generatePDFDataURL(state.outputresults, state.form, state.data.reporturl, state.data.formhandlerurl);
            if(resultsurl !== false) {
                formsent = true;
            }
        }
        return Object.assign({}, state, {formvalid: formvalidation.formvalid, formerrors: formvalidation.formerrors, formsent: formsent, resultsurl: resultsurl });
    }

    return state;
};

export default rootReducer;

function generatePDFDataURL(results, form, dataurl, formhandlerurl) {
    let responseobj = {};

    for( let i=0; i<results.length; i++ ) {
        for( let j=1; j<results[i].length; j++ ) {
            responseobj['s'+i+'q'+j] = convertAverageToVisual(results[i][j].average,results[i][j].unsure);
        }
    }

    let url = dataurl + '?dl=' + btoa(JSON.stringify(Object.assign({}, {results: responseobj, form: form} )))

    getBitlyLink(url)
        .then((resultsurl) => {
            let postdata = Object.assign({}, {firstname: form.firstname, lastname: form.lastname, email: form.email , phone: form.phone , organisation: form.organisation , jobtitle: form.jobtitle , resultsurl: resultsurl } );
            // todo post the form to pardot form handler here?
            axios.jsonp(formhandlerurl,{timeout: 1000, params: postdata})
                .then(res => {
                    console.log(res);
                    console.log(res.data);
                });
            return true;
        })
        .catch((err) => {
            console.log(err);
            return false;
        });
}

async function getBitlyLink(url) {
    const response = await bitly.shorten(url)
    return response.link
}

function convertAverageToVisual(avg, type) {
    if(avg === 0)
        return 'unsure';
    if(avg <= 50 && type)
        return 'earlyunsure';
    if(avg <= 50 && !type)
        return 'early';
    if(avg <= 75)
        return 'developing';
    if(avg <= 99)
        return 'maturing';
    return 'mature';
}

function ValidateForm(values, types, errors) {
    let formvalid = true;
    let formerrors =  Object.assign({}, errors );

    for (let [key, value] of Object.entries(values)) {
        let fieldstate = ValidateDataInError(value, types[key]);
        formerrors[key] = fieldstate;
        if(fieldstate)
            formvalid = false;
    }

    return Object.assign({}, { formvalid: formvalid, formerrors: formerrors } );
}

function ValidateDataInError(value, type) {
    if( type === 'text' ) {
        if(value === '')
            return true;
    }
    if( type === 'email' ) {
        if(!validateEmail(value))
            return true;
    }
    if( type === 'phone' ) {
        if(!validatePhoneNumber(value))
            return true;
    }
    return false
}

function validateEmail(email) {
    const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(String(email).toLowerCase());
}

function validatePhoneNumber(number) {
    // original regex (but to many unnecessary escaped characters?) const re = /^(\+\d{2}[ \-]{0,1}){0,1}(((\({0,1}[ \-]{0,1})0{0,1}\){0,1}[2|3|7|8]{1}\){0,1}[ \-]*(\d{4}[ \-]{0,1}\d{4}))|(1[ \-]{0,1}(300|800|900|902)[ \-]{0,1}((\d{6})|(\d{3}[ \-]{0,1}\d{3})))|(13[ \-]{0,1}([\d \-]{5})|((\({0,1}[ \-]{0,1})0{0,1}\){0,1}4{1}[\d \-]{8,10})))$/;
    const re = /^(\+\d{2}[ -]{0,1}){0,1}(((\({0,1}[ -]{0,1})0{0,1}\){0,1}[2|3|7|8]{1}\){0,1}[ -]*(\d{4}[ -]{0,1}\d{4}))|(1[ -]{0,1}(300|800|900|902)[ -]{0,1}((\d{6})|(\d{3}[ -]{0,1}\d{3})))|(13[ -]{0,1}([\d -]{5})|((\({0,1}[ -]{0,1})0{0,1}\){0,1}4{1}[\d -]{8,10})))$/;
    return re.test(String(number));
}

function calculateFinalResults(modules, results) {
    let outputResults = [];
    for (let j = 0 ; j < results.length; ++j ){
        if( outputResults[j] === undefined ) {
            outputResults[j] = [];
        }
        const thismodule = modules[j];
        const thisresults = results[j];
        for (let i = 0; i < thisresults.length; ++i ) {
            if (outputResults[j][thismodule.submodules[i].id] === undefined) {
                outputResults[j][thismodule.submodules[i].id] = { title: thismodule.submodules[i].heading, totalquestions: 1, totalresponse : thisresults[i].weight, average: thisresults[i].weight, unsure: checkUnsure(thisresults[i].weight) }
            } else {
                outputResults[j][thismodule.submodules[i].id] = Object.assign({}, outputResults[j][thismodule.submodules[i].id], {
                    totalquestions: (outputResults[j][thismodule.submodules[i].id].totalquestions + 1),
                    totalresponse: (outputResults[j][thismodule.submodules[i].id].totalresponse + thisresults[i].weight),
                    average: (outputResults[j][thismodule.submodules[i].id].totalresponse + thisresults[i].weight) / (outputResults[j][thismodule.submodules[i].id].totalquestions + 1),
                    unsure: doubleCheckUnsure(outputResults[j][thismodule.submodules[i].id].unsure,thisresults[i].weight)
                });
            }
        }
    }
    return outputResults;
}

function checkUnsure(weight) {
    if (weight === 0) {
        return true
    } else {
        return false
    }
}

function doubleCheckUnsure(current, weight) {
    if(!current) {
        if (weight === 0) {
            return true
        } else {
            return false
        }
    } else {
        return true
    }
}

function UpdateFormData(form, field, value) {
    return Object.assign({}, form, { [field]: value});
}

function IncrementStep(array, id) {
    let currentStep = array[id].step;
    let newArray = [...array];
    newArray[id] = {...newArray[id], step: ++currentStep};
    return newArray;
}

// function HideModuleButton(object, id) {
//     let newArray = [...object.modulecomplete];
//     newArray[id] = "hide remove";
//     let newObject =  Object.assign({}, object, {modulecomplete : newArray});
//     return newObject;
// }

function UpdateResult(array, module, submodule, answer, weight, totalquestions ) {
    // update the results state array with question response
    let newArray = [...array];
    if (newArray[module] === undefined) {
        newArray[module] = [];
    }
    if (newArray[module][submodule] === undefined) {
        newArray[module][submodule] = [];
    }
    newArray[module][submodule] = { answer: answer, weight: weight };

    // calculate the new module total as we go
    if (newArray[module]['total'] === undefined) {
        newArray[module]['total'] = 0;
    }
    const sum = newArray[module]
        .map( v => v['weight'] )
        .reduce( (sum, current) => sum + current, 0 );
    newArray[module]['total'] = sum / totalquestions;

    return newArray;
}